<template>
  <div class="dbConfig">
    <div>
      <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
        <el-tab-pane v-for="(item,index) in visibleMenus" :key="index" :name="item.name" :label="item.label" />
      </el-tabs>
    </div>
    <div class="over-main">
      <!-- :include="['DbNavManage']" -->
      <router-view v-slot="{ Component }">
        <keep-alive :include="['dbNavList', 'AbnormalMonitoring']">
          <component :is="Component" />
        </keep-alive>
      </router-view>
      <!-- <router-view></router-view> -->
    </div>
  </div>
</template>

<script>
import store from "@/store/index";

export default {
  name: 'DbNavManage',
  watch: {
    $route: {
      immediate: true,
      handler(newVal, oldVal) {
        this.act = newVal.path;
        const path = newVal.path;
        this.menus.forEach(item => {
          if (path.endsWith(item.name)) {
            this.activeName = item.name;
          }
        })
      },
    }
  },
  data() {
    return {
      activeName: 'dbNavList',
      menus: [
        {
          name: 'dbNavList',
          label: '导航列表'
        },
        {
          name: 'UserPermissions',
          label: '用户组权限'
        },
        {
          name: 'UserResponsibility',
          label: '责任馆员管理',
          notNankai: true
        },
        {
          name: 'copyrightNotice',
          label: '版权公告'
        },
        {
          name: 'AbnormalMonitoring',
          label: '异常监控',
          notNankai: true
        },
        {
          name: 'ProblemFeedbackNotice',
          label: '问题反馈公告',
          onlyNankai: true
        },
        {
          name: 'OffCampusAccessGuide',
          label: '校外访问指南',
          onlyNankai: true
        },
        {
          name: 'globalSetting',
          label: '全局设置'
        }
      ]
    }
  },
  computed: {
    // 南开(sId=129)不显示"用户组权限"tab
    isNankai() {
      const userData = store.state.user.userData || {};
      const sId = Number(userData.schoolId || userData.sId);
      return sId === 129;
    },
    visibleMenus() {
      return this.menus.filter(item => {
        // 南开(sId=129)不显示"用户组权限"tab
        if (this.isNankai && item.name === 'UserPermissions') {
          return false;
        }
        // 仅南开显示的tab
        if (!this.isNankai && item.onlyNankai) {
          return false;
        }
        // 南开不显示的tab
        if (this.isNankai && item.notNankai) {
          return false;
        }
        return true;
      });
    }
  },
  created() {

  },
  methods: {
    handleClick(tab, event) {
      this.$router.push("/dbConfig/dbNavManage/" + tab.props.name)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.dbConfig {
  //padding: 20px;
}

::v-deep(.el-tabs__header) {
  margin: 0;
}
</style>
